import { DOCUMENT_TYPE_LABELS } from "../constants/priceMaster";
import { type ResearchRequestFormData } from "../types";

type RequestedDocuments = Pick<
  ResearchRequestFormData,
  "selectedDocuments" | "customDocuments"
>;

export const getRequestedDocumentLabels = (
  data: RequestedDocuments
): string[] => {
  const selectedDocumentLabels = data.selectedDocuments.map(
    (documentType) => DOCUMENT_TYPE_LABELS[documentType]
  );
  const customDocumentLabels = data.customDocuments
    .map((document) => document.trim())
    .filter((document) => document !== "");

  return [...selectedDocumentLabels, ...customDocumentLabels];
};
